// Редьюсер для управления состоянием игры
export default function gameReducer(state, action) {
  switch (action.type) {
    case 'SET_RECOGNIZED_TEXT':
      return { ...state, recognizedText: action.payload };
    case 'SET_AUDIO_BLOB':
      return { ...state, audioBlob: action.payload };
    case 'SET_CURRENT_SENTENCE':
      return {
        ...state,
        currentSentenceIndex: action.payload,
        recognizedText: '',
        audioBlob: null,
        correctAnswer: null,
      };
    case 'SET_CORRECT_ANSWER':
      return { ...state, correctAnswer: action.payload };
	case 'UPDATE_FIRE_LEVEL':
	  if (state.fireLevel === 0 || state.lives === 0 || state.gameWon) {
		return state; // 🔒 блокируем увеличение огня
	  }
	  return { ...state, fireLevel: Math.max(0, Math.min(20, state.fireLevel + action.payload)) };	  
    case 'DECREMENT_LIVES':
      return { ...state, lives: Math.max(0, state.lives - 1) };
    case 'SET_WORD_POSITION':
      return { ...state, wordPosition: action.payload };
	case 'INCREMENT_PHRASES_COUNT':
	  return { ...state, phrasesCount: state.phrasesCount + 1 };	  
	case 'SET_SERVER_RESPONSE':
	  return { ...state, phrasesCount: 0 };	 
	case 'SET_AUDIO_TIME_ENDED':
	  return { ...state, audioTimeEnded: action.payload }; 	  
	case 'RESET_AUDIO_TIME_ENDED':
	  return { ...state, audioTimeEnded: false };	  
  case 'INCREMENT_LIVES':
    return { ...state, lives: Math.min(state.lives + 1, 10) };  
  case 'RESET_GAME':
      return {
        ...state,
        fireLevel: 5,
        lives: 10,
        currentSentenceIndex: 0,
        recognizedText: '',
        audioBlob: null,
        correctAnswer: null,
        wordPosition: 0,
      };
    default:
      return state;
  }
}